function initMoreAbout(section) {
  if (!section) return;

  const slider = section.querySelector('.more-about-slider');
  const slides = section.querySelectorAll('.more-about-slide');
  const prevBtn = section.querySelector('.more-about-arrow-left');
  const nextBtn = section.querySelector('.more-about-arrow-right');
  const dotsContainer = section.querySelector('.more-about-dots');
  const container = section.querySelector('.more-about-container');

  if (!slider || slides.length === 0) return;

  let index = 0;
  const totalSlides = slides.length;
  const desktopColumns = parseInt(section.getAttribute('data-desktop-columns'), 10) || 4;

  function isMobile() {
    return window.innerWidth < 768;
  }

  function slidesPerScreen() {
    return isMobile() ? 1 : desktopColumns;
  }

  function maxIndex() {
    return Math.max(totalSlides - slidesPerScreen(), 0);
  }

  function slideWidth() {
    if (!container) return 0;
    return container.offsetWidth / slidesPerScreen();
  }

  function updateSlider() {
    slider.style.transform = 'translateX(-' + (slideWidth() * index) + 'px)';
    updateDots();
    updateArrowStates();
  }

  function updateArrowStates() {
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= maxIndex();
  }

  function updateDots() {
    if (!dotsContainer) return;
    dotsContainer.querySelectorAll('button').forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

  function setupDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    if (!isMobile()) return;

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.onclick = () => {
        index = i;
        updateSlider();
      };
      dotsContainer.appendChild(dot);
    });
    updateDots();
  }

  if (prevBtn) {
    prevBtn.onclick = () => {
      index = Math.max(index - 1, 0);
      updateSlider();
    };
  }

  if (nextBtn) {
    nextBtn.onclick = () => {
      index = Math.min(index + 1, maxIndex());
      updateSlider();
    };
  }

  let startX = 0;
  slider.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });
  slider.addEventListener('touchend', (e) => {
    if (!isMobile()) return;
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      index = diff > 0
        ? Math.min(index + 1, totalSlides - 1)
        : Math.max(index - 1, 0);
      updateSlider();
    }
  });

  setupDots();
  updateSlider();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      index = Math.min(index, maxIndex());
      setupDots();
      updateSlider();
    }, 150);
  });
}

document.querySelectorAll('.more-about-section').forEach(initMoreAbout);

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.more-about-section');
  if (section) initMoreAbout(section);
});
